import React from "react";

import Project from "./project";

import INFO from "../../data/user";

import "./styles/allProjects.css";

const AllProjects = ({ projects }) => {
	const list = projects ?? INFO.projects;
	return (
		<div className="all-projects-container">
			{list.map((project, index) => (
				<div className="all-projects-project" key={index}>
					<Project
						logo={project.logo}
						title={project.title}
						description={project.description}
						linkText={project.linkText}
						link={project.link}
						index={index}
						stage={project.stage}
						tags={project.tags}
					/>
				</div>
			))}
		</div>
	);
};

export default AllProjects;
